import { useEffect } from "react";
import { Table, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { creditFlagRender, momentFormat } from "@/utils/utils";
import { adjustDataModel } from "./adjustDataModel";
import { IAccountAdjustDetail } from "@/views/account/AccountTypes";

export function AdjustDataTable() {

    const {
        loading, dataSource, selectedRowKeys, pgCfg,
        loadData, onSearch,
        setSelectedRowKeys, setSelectedData,
        setDetail, setAdjustMonthDrawerVisible,
    } = adjustDataModel();

    const columns: ColumnsType<IAccountAdjustDetail> = [
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
            width: 80,
        },
        {
            title: '',
            dataIndex: '',
            width: 60,
            align: 'center',
            render: (t, r) => {
                if (new Date(r?.createTime ?? '').getTime() > new Date('2024-05-28 13:34:30').getTime()) {
                    return <Typography.Link onClick={() => { setDetail(r); setAdjustMonthDrawerVisible(true) }} >详情</Typography.Link>
                }
            }
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
            width: 450,
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            width: 120,
            render: (v) => creditFlagRender(v)
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
            width: 120,
        },
        {
            align: "center",
            title: '账户实体',
            dataIndex: 'beName',
            width: 300,
        },
        {
            align: "center",
            title: '授信额度',
            dataIndex: 'creditAmount',
            width: 120,
        },
        {
            align: "center",
            title: '调整额度',
            dataIndex: 'adjustAmount',
            width: 120,
        },
        {
            align: "center",
            title: '调额类型',
            dataIndex: 'type',
            width: 120,
            render: (v) => v == 0 ? '目标调额' : '增量调额'
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'createUser',
            width: 120,
        },
        {
            align: "center",
            title: '调额日期',
            dataIndex: 'createTime',
            width: 200,
        },
        {
            align: "center",
            title: '审核状态',
            dataIndex: 'status',
            width: 120,
            render: (v) =>
                v === 0 ? '初始'
                    : v === 1 ? '审核中'
                        : v === 2 ? '审核通过'
                            : v === 3
                                ? '撤回'
                                : v === 8 ? '审核驳回'
                                    : v === 9 ? '失败'
                                        : ''
        },
        {
            align: "center",
            title: '审核时间',
            dataIndex: 'approvalTime',
            width: 180,
            render: (text) => momentFormat(text) ?? ''
        },
        {
            align: "center",
            title: '审核员',
            width: 100,
            dataIndex: 'approver',
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
    ];

    useEffect(() => {
        onSearch();
    }, [])

    return (
        <>
            <Table
                loading={loading}
                rowKey={record => record.key}
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountAdjustDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setSelectedData(selectedRows);
                    }
                }}
                pagination={{
                    ...pgCfg,
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: '2600px', y: "calc(100vh - 446px)" }}
            />
        </>
    )
}

